// The closed set of capabilities withheld from the release scope (ADR-0034). One key per thing that
// ships as a unit, never one per surface — nobody wants the Support graph without the Support tab.
// Lives in `types` because both `lib` (the env schema that validates them) and `config` (the gate
// that reads them) need the same list, and `lib` may import nothing above `types`.
export const PREVIEW_FEATURES = [
  'support',
  'subscriptions',
  'activity-log',
  'device-telemetry',
  'customer-map',
  'notifications',
  // Parameter Templates push to Digital Matter and trigger the FieldPro connector sync, which the
  // Tracking app consumes — withheld from Release 1 on the user's call (2026-09-24).
  'dm-configuration',
  // CropX devices are not sold in Release 1: the CropX Device Type option is withheld from the Add
  // Device form and every Device Type filter (ADO 121238).
  'cropx',
  // Dealer Management (feature 118478) is Release 2 work: the Dealers tab, the Customer listing's
  // dealer columns/filters, the dealer Customer Detail variant and Order History's dealer rows
  // (grilling Q1, ADR-0036).
  'dealers',
] as const;

export type PreviewFeature = (typeof PREVIEW_FEATURES)[number];
